/*
  <maratona-carrossel> — setas para uma lista com rolagem lateral
  ---------------------------------------------------------------
  A rolagem em si é CSS puro (overflow + scroll-snap): no celular a cliente
  arrasta com o dedo e nada disso aqui é necessário. O JS só existe para o
  desktop, onde mouse não rola na horizontal com facilidade:
  - as setas andam quase uma "tela" do trilho por clique;
  - cada seta some quando não há mais para onde ir;
  - se tudo cabe na tela, as duas setas somem (classe .sem-rolagem).

  Usado por sections/maratona-categorias-circulares.liquid (layout carrossel).
*/
class MaratonaCarrossel extends HTMLElement {
  connectedCallback() {
    this.trilho = this.querySelector('[data-carrossel-trilho]');
    this.anterior = this.querySelector('[data-carrossel-anterior]');
    this.proxima = this.querySelector('[data-carrossel-proxima]');
    if (!this.trilho) return;

    // Respeita quem pediu menos animação no sistema
    this.suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.anterior) this.anterior.addEventListener('click', () => this.andar(-1));
    if (this.proxima) this.proxima.addEventListener('click', () => this.andar(1));

    // Atualiza as setas no máximo uma vez por quadro, não a cada evento de scroll
    this.agendado = false;
    const agendar = () => {
      if (this.agendado) return;
      this.agendado = true;
      requestAnimationFrame(() => {
        this.agendado = false;
        this.atualizarSetas();
      });
    };
    this.trilho.addEventListener('scroll', agendar, { passive: true });

    // Mudou a largura da janela (ou o editor do tema redimensionou): recalcula
    if ('ResizeObserver' in window) {
      this.observador = new ResizeObserver(agendar);
      this.observador.observe(this.trilho);
    } else {
      window.addEventListener('resize', agendar);
    }

    this.atualizarSetas();
  }

  disconnectedCallback() {
    if (this.observador) this.observador.disconnect();
  }

  andar(direcao) {
    // 85% da largura visível: a última bolinha da vista atual reaparece como
    // referência na próxima, então a cliente não perde o fio da lista
    const passo = Math.round(this.trilho.clientWidth * 0.85) * direcao;
    this.trilho.scrollBy({ left: passo, behavior: this.suave ? 'smooth' : 'auto' });
  }

  atualizarSetas() {
    const { scrollLeft, clientWidth, scrollWidth } = this.trilho;
    const folga = 2; // arredondamento de subpixel
    const temRolagem = scrollWidth > clientWidth + folga;

    this.classList.toggle('sem-rolagem', !temRolagem);
    if (this.anterior) this.anterior.disabled = !temRolagem || scrollLeft <= folga;
    if (this.proxima) this.proxima.disabled = !temRolagem || scrollLeft + clientWidth >= scrollWidth - folga;
  }
}

if (!customElements.get('maratona-carrossel')) {
  customElements.define('maratona-carrossel', MaratonaCarrossel);
}
